<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="description" label="版本更新内容">
          <a-textarea placeholder="请输入版本更新内容" v-model="model.description" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="editionUrl" label="请上传更新文件">
          <a-upload
            :maxCount="1"
            :action="apiBaseUrl + '/sys/common/upload'"
            :data="{ biz: 'aigoes-ai-school/upgradePack', bucket:'aigoes-public' }"
            @change="handleChange"
            :headers="{ 'X-Access-Token': token }"
            accept="wgt,ipa, apk"
       
            v-model:file-list="fileList"
          >
            <a-button> Upload </a-button>
          </a-upload>

          <!-- <a-input
            placeholder="请输入apk、wgt包下载地址或者应用市场地址  安卓应用市场 market://details?id=xxxx 苹果store itms-apps://itunes.apple.com/cn/app/xxxxxx"
            v-model="model.editionUrl"
          /> -->
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="editionForce" label="是否强制更新">
          <a-radio-group v-model="model.editionForce">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
          <!-- <a-input-number placeholder="0否 1是" v-model="model.editionForce" /> -->
        </a-form-model-item>
        <!--        label="0是整包升级 1是wgt升级" -->
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="packageType" label="是否真整包升级">
          <a-radio-group v-model="model.packageType">
            <a-radio :value="1">否(wgt升级)</a-radio>
            <a-radio :value="0">是</a-radio>
          </a-radio-group>
          <!-- <a-input-number v-model="model.packageType" /> -->
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="editionIssue" label="是否发行">
          <a-radio-group v-model="model.editionIssue">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
          <!-- <a-input-number placeholder="0否 1是" v-model="model.editionIssue" /> -->
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="editionNumber" label="版本号">
          <a-input-number v-model="model.editionNumber" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="editionName" label="版本名称">
          <a-input placeholder="请输入版本名称 manifest里的版本名称" v-model="model.editionName" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="editionSilence" label="是否静默更新">
          <!-- <a-input-number placeholder="0否 1是" v-model="model.editionSilence" /> -->
          <a-radio-group v-model="model.editionSilence">
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import Vue from 'vue'
import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'
import moment from 'moment'

export default {
  name: 'VersionUpdateModal',

  data() {
    return {
      token: Vue.ls.get(ACCESS_TOKEN),
      apiBaseUrl: window._CONFIG['domianURL'] || '/jeecg-boot',
      title: '操作',
      visible: false,
      model: {
       
      },
      fileList:[],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },

      confirmLoading: false,
      validatorRules: {},
      url: {
        add: '/VersionUpdate/add',
        edit: '/VersionUpdate/edit',
      },
    }
  },
  created() {},
  methods: {
    add() {
      //初始化默认值
      this.edit({})
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.$refs.form.clearValidate()
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          console.log(123,this.fileList)
          console.log(123,this.model)

          // if (this.model.fileList.file.response) {
          //   this.model.editionUrl = this.model.fileList.file.response.message
          // } else if (this.model.fileList.file.response.code != 0) {
          //   return that.$message.warning('文件上传失败 请重新上传')
          // } else {
          //   return that.$message.warning('请等待文件上传完成')
          // }
          
          httpAction(httpurl, this.model, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.close()
    },
    handleChange(e) {
      console.log(e);
      
      if (e.file.response && e.file.response.code == 0) {
        this.model.editionUrl = e.file.response.message
      }
    },
  },
}
</script>

<style lang="less" scoped></style>
